import React from 'react'

const EditPenIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7169 2.9079C12.9505 2.6829 12.9505 2.31943 12.7169 2.09443L11.3154 0.744434C11.0818 0.519434 10.7044 0.519434 10.4708 0.744434L9.29688 1.8752L11.543 4.03866L12.7169 2.9079ZM10.944 4.61559L8.69792 2.45213L2.70833 8.22136V10.3848H4.95443L10.944 4.61559ZM14.6875 12.1156H0.3125V14.4233H14.6875V12.1156Z"
        fill="#B0B0B0"
      />
    </svg>
  )
}

export default EditPenIcon
